import { defineComponent as q, ref as y, inject as G, watchEffect as Q, computed as O, vShow as Y, onBeforeUnmount as Z, watch as ee, toRef as oe, provide as x, h as i, Transition as te, mergeProps as re, withDirectives as ne, Fragment as ae } from "vue";
import { drawerBodyInjectionKey as ie } from "./ghl-ui.es989.js";
import { modalBodyInjectionKey as le } from "./ghl-ui.es1053.js";
import { popoverBodyInjectionKey as se } from "./ghl-ui.es1345.js";
import de from "./ghl-ui.es1374.js";
import ue from "./ghl-ui.es854.js";
import L from "./ghl-ui.es855.js";
import { isJsdom as ce } from "./ghl-ui.es1375.js";
import z from "./ghl-ui.es718.js";
import fe from "./ghl-ui.es717.js";
import { formatLength as T } from "./ghl-ui.es991.js";
import { useThemeClass as ve } from "./ghl-ui.es857.js";
import { getPreciseEventTarget as D } from "./ghl-ui.es875.js";
import { useAdjustedTo as E } from "./ghl-ui.es877.js";
import he from "./ghl-ui.es880.js";
import me from "./ghl-ui.es1166.js";
import { isSlotEmpty as F, resolveWrappedSlot as _ } from "./ghl-ui.es860.js";
import { FocusTrap as we } from "./ghl-ui.es1222.js";
import { XScrollbar as ye } from "./ghl-ui.es994.js";
const ge = Object.assign(Object.assign({}, L.props), {
  to: E.propTo,
  show: Boolean,
  trigger: String,
  showArrow: Boolean,
  delay: Number,
  duration: Number,
  raw: Boolean,
  arrowPointToCenter: Boolean,
  arrowClass: String,
  arrowStyle: [String, Object],
  arrowWrapperClass: String,
  arrowWrapperStyle: [String, Object],
  displayDirective: String,
  x: Number,
  y: Number,
  flip: Boolean,
  overlap: Boolean,
  placement: String,
  width: [Number, String],
  keepAliveOnHover: Boolean,
  scrollable: Boolean,
  contentClass: String,
  contentStyle: [Object, String],
  headerClass: String,
  headerStyle: [Object, String],
  footerClass: String,
  footerStyle: [Object, String],
  // private
  internalDeactivateImmediately: Boolean,
  animated: Boolean,
  onClickoutside: Function,
  internalTrapFocus: Boolean,
  internalOnAfterLeave: Function,
  // deprecated
  minWidth: Number,
  maxWidth: Number
}), pe = ({
  arrowClass: e,
  arrowStyle: l,
  arrowWrapperClass: g,
  arrowWrapperStyle: p,
  clsPrefix: f
}) => i("div", {
  key: "__popover-arrow__",
  style: p,
  class: [`${f}-popover-arrow-wrapper`, g]
}, i("div", {
  class: [`${f}-popover-arrow`, e],
  style: l
})), ze = q({
  name: "PopoverBody",
  inheritAttrs: !1,
  props: ge,
  setup(e, {
    slots: l,
    attrs: g
  }) {
    const {
      namespaceRef: p,
      mergedClsPrefixRef: f,
      inlineThemeDisabled: j
    } = ue(e), H = L("Popover", "-popover", de, me, e, f), M = y(null), n = G("NPopover"), b = y(null), C = y(e.show), h = y(!1);
    Q(() => {
      const {
        show: o
      } = e;
      o && !ce() && !e.internalDeactivateImmediately && (h.value = !0);
    });
    const K = O(() => {
      const {
        trigger: o,
        onClickoutside: r
      } = e, a = [], {
        positionManuallyRef: {
          value: t
        }
      } = n;
      return t || (o === "click" && !r && a.push([z, k, void 0, {
        capture: !0
      }]), o === "hover" && a.push([fe, J])), r && a.push([z, k, void 0, {
        capture: !0
      }]), (e.displayDirective === "show" || e.animated && h.value) && a.push([Y, e.show]), a;
    }), N = O(() => {
      const o = e.width === "trigger" ? void 0 : T(e.width), r = [];
      o && r.push({
        width: o
      });
      const {
        maxWidth: a,
        minWidth: t
      } = e;
      return a && r.push({
        maxWidth: T(a)
      }), t && r.push({
        maxWidth: T(t)
      }), j || r.push(P.value), r;
    }), P = O(() => {
      const {
        common: {
          cubicBezierEaseInOut: o,
          cubicBezierEaseIn: r,
          cubicBezierEaseOut: a
        },
        self: {
          space: t,
          spaceArrow: S,
          padding: B,
          fontSize: c,
          textColor: m,
          dividerColor: u,
          color: v,
          boxShadow: w,
          borderRadius: R,
          arrowHeight: $,
          arrowOffset: d,
          arrowOffsetVertical: X
        }
      } = H.value;
      return {
        "--n-box-shadow": w,
        "--n-bezier": o,
        "--n-bezier-ease-in": r,
        "--n-bezier-ease-out": a,
        "--n-font-size": c,
        "--n-text-color": m,
        "--n-color": v,
        "--n-divider-color": u,
        "--n-border-radius": R,
        "--n-arrow-height": $,
        "--n-arrow-offset": d,
        "--n-arrow-offset-vertical": X,
        "--n-padding": B,
        "--n-space": t,
        "--n-space-arrow": S
      };
    }), s = j ? ve("popover", void 0, P, e) : void 0;
    n.setBodyInstance({
      syncPosition: V
    }), Z(() => {
      n.setBodyInstance(null);
    }), ee(oe(e, "show"), (o) => {
      e.animated || (o ? C.value = !0 : C.value = !1);
    });
    function V() {
      var o;
      (o = M.value) === null || o === void 0 || o.syncPosition();
    }
    function A(o) {
      e.trigger === "hover" && e.keepAliveOnHover && e.show && n.handleMouseEnter(o);
    }
    function I(o) {
      e.trigger === "hover" && e.keepAliveOnHover && n.handleMouseLeave(o);
    }
    function J(o) {
      e.trigger === "hover" && !W().contains(D(o)) && n.handleMouseMoveOutside(o);
    }
    function k(o) {
      (e.trigger === "click" && !W().contains(D(o)) || e.onClickoutside) && n.handleClickOutside(o);
    }
    function W() {
      return n.getTriggerElement();
    }
    x(se, b), x(ie, null), x(le, null);
    function U() {
      if (s == null || s.onRender(), !(e.displayDirective === "show" || e.show || e.animated && h.value))
        return null;
      let r;
      const a = n.internalRenderBodyRef.value, {
        value: t
      } = f;
      if (a)
        r = a(
          // The popover class and overlap class must exists, they will be used
          // to place the body & transition animation.
          // Shadow class exists for reuse box-shadow.
          [`${t}-popover-shared`, s == null ? void 0 : s.themeClass.value, e.overlap && `${t}-popover-shared--overlap`, e.showArrow && `${t}-popover-shared--show-arrow`, e.arrowPointToCenter && `${t}-popover-shared--center-arrow`],
          b,
          N.value,
          A,
          I
        );
      else {
        const {
          value: S
        } = n.extraClassRef, {
          internalTrapFocus: B
        } = e, c = !F(l.header) || !F(l.footer), m = () => {
          var u, v;
          const w = c ? i(ae, null, _(l.header, (d) => d ? i("div", {
            class: [`${t}-popover__header`, e.headerClass],
            style: e.headerStyle
          }, d) : null), _(l.default, (d) => d ? i("div", {
            class: [`${t}-popover__content`, e.contentClass],
            style: e.contentStyle
          }, l) : null), _(l.footer, (d) => d ? i("div", {
            class: [`${t}-popover__footer`, e.footerClass],
            style: e.footerStyle
          }, d) : null)) : e.scrollable ? (u = l.default) === null || u === void 0 ? void 0 : u.call(l) : i("div", {
            class: [`${t}-popover__content`, e.contentClass],
            style: e.contentStyle
          }, l), R = e.scrollable ? i(ye, {
            contentClass: c ? void 0 : `${t}-popover__content ${(v = e.contentClass) !== null && v !== void 0 ? v : ""}`,
            contentStyle: c ? void 0 : e.contentStyle
          }, {
            default: () => w
          }) : w, $ = e.showArrow ? pe({
            arrowClass: e.arrowClass,
            arrowStyle: e.arrowStyle,
            arrowWrapperClass: e.arrowWrapperClass,
            arrowWrapperStyle: e.arrowWrapperStyle,
            clsPrefix: t
          }) : null;
          return [R, $];
        };
        r = i("div", re({
          class: [`${t}-popover`, `${t}-popover-shared`, s == null ? void 0 : s.themeClass.value, S.map((u) => `${t}-${u}`), {
            [`${t}-popover--scrollable`]: e.scrollable,
            [`${t}-popover--show-header-or-footer`]: c,
            [`${t}-popover--raw`]: e.raw,
            [`${t}-popover-shared--overlap`]: e.overlap,
            [`${t}-popover-shared--show-arrow`]: e.showArrow,
            [`${t}-popover-shared--center-arrow`]: e.arrowPointToCenter
          }],
          ref: b,
          style: N.value,
          onKeydown: n.handleKeydown,
          onMouseenter: A,
          onMouseleave: I
        }, g), B ? i(we, {
          active: e.show,
          autoFocus: !0
        }, {
          default: m
        }) : m());
      }
      return ne(r, K.value);
    }
    return {
      displayed: h,
      namespace: p,
      isMounted: n.isMountedRef,
      zIndex: n.zIndexRef,
      followerRef: M,
      adjustedTo: E(e),
      followerEnabled: C,
      renderContentNode: U
    };
  },
  render() {
    return i(he, {
      ref: "followerRef",
      zIndex: this.zIndex,
      show: this.show,
      enabled: this.followerEnabled,
      to: this.adjustedTo,
      x: this.x,
      y: this.y,
      flip: this.flip,
      placement: this.placement,
      containerClass: this.namespace,
      overlap: this.overlap,
      width: this.width === "trigger" ? "target" : void 0,
      teleportDisabled: this.adjustedTo === E.tdkey
    }, {
      default: () => this.animated ? i(te, {
        name: "popover-transition",
        appear: this.isMounted,
        // Don't use watch to enable follower, since the transition may
        // make position sync timing very subtle and buggy.
        onEnter: () => {
          this.followerEnabled = !0;
        },
        onAfterLeave: () => {
          var e;
          (e = this.internalOnAfterLeave) === null || e === void 0 || e.call(this), this.followerEnabled = !1, this.displayed = !1;
        }
      }, {
        default: this.renderContentNode
      }) : this.renderContentNode()
    });
  }
});
export {
  ze as default,
  ge as popoverBodyProps,
  pe as renderArrow
};
